import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';

export const DemographicsCardWrapper = styled.div`
  min-height: 168px;
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    min-height: 316px;
  `}
  width: 100%;
`;

export const DemographicsCardAlignWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 32px 32px 56px;
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    justify-content: center;
    flex-direction: column;
  `}
  width: 100%;
`;

export const DemographicsCardText = styled(H3)`
  color: ${({ theme }) => theme.colors.insights.livability};
  margin-left: 24px;
  ${({ theme }) => theme.media.showAt({ to: 1 })`
		margin: 0 20px;
    text-align: center;
    font-size: 21px;
  `}
  text-align: left;
`;

export const DemographicsCardIconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${({ theme }) => colorToAlpha(theme.colors.insights.livability, 0.08)};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    margin-bottom: 24px;
    width: 100px;
    height: 100px;
  `}
  svg {
    width: 46px;
    ${({ theme }) => theme.media.showAt({ to: 1 })`
      width: 64px;
    `}
  }
`;

export const DemographicsWidgetWrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  box-shadow: 0 3px 8px 0 ${({ theme }) => colorToAlpha(theme.colors.neutrals.black, 0.08)};
`;
